<template>
  <!-- <CurrencyInput
    class="input-text-border-none align-right"
    v-model:value="value"
    @blur="changeInput"
    @click="onClick"
  /> -->
  <VxCurrencyInput
    v-model="value"
    class="input-text-border-none input11 input-text-border-none align-left"
    :class="textAlign"
    @blur="changeInput"
    @click="onClick"
  />
</template>

<script>
import { defineComponent } from 'vue'
import VxCurrencyInput from '@/components/ui/VxCurrencyInput.vue'
export default defineComponent({
  // props: {
  //   params: {
  //     type: Object,
  //     default: null
  //   }
  // },
  components: { VxCurrencyInput },
  data() {
    return {
      value: null,
      colName: null,
      textAlign: 'align-right'
      // readOnly: false
    }
  },
  beforeMount() {
    if (this.params?.value !== null && this.params?.value !== undefined) {
      this.value = this.params.value
    }
    if (
      this.params?.textAlign !== null &&
      this.params?.textAlign !== undefined
    ) {
      this.textAlign = this.params.textAlign
    }
    // if (this.params.readOnly) {
    //   this.readOnly = this.params.readOnly
    // }
    this.params.colName
      ? (this.colName = this.params.colName)
      : (this.colName = this.params.column.colId)
  },
  methods: {
    changeInput() {
      this.params.context.componentParent.changeCurrencyInput(
        this.params,
        this.value,
        this.colName
      )
    },
    onClick(e) {
      e.stopPropagation()
    }
  }
})
</script>
